import { InferType, object } from 'yup';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

export const resetPasswordWithTokenSchema = object({
    token: safeString().required('Token can not be empty.'),
    username: safeString().required('Username can not be empty.'),
    new_password: safeString().required('New Password can not be empty.'),
    confirm_new_password: safeString()
        .required('Confirm Password can not be empty.')
        .test('passwords-match', 'Confirm Password does not match with the New Password.', function (value) {
            return this.parent.new_password === value;
        })
});

export type ResetPasswordWithTokenFormValues = InferType<typeof resetPasswordWithTokenSchema>;
export type ResetPasswordWithTokenFormInput = Nullable<ResetPasswordWithTokenFormValues>;
